import { Farewell } from '@/landing/components/sections/Farewell/Farewell';
import Head from 'next/head';

export default function Home() {
  return (
    <>
      <Head>
        <title>Nerdbord — Dziękujemy</title>
        <meta
          name="description"
          content="Nerdbord kończy działalność. Dziękujemy wszystkim, którzy uczyli się z nami budować produkty cyfrowe."
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <link rel="icon" href="/favicon/favicon.ico" />
      </Head>
      <Farewell />
    </>
  );
}
